import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ProblemSection from "./components/ProblemSection";
import FeatureGrid from "./components/FeatureGrid";
import CategoryGrid from "./components/CategoryGrid";
import CTASection from "./components/CTASection";
import ArticleCardsSection from "./components/ArticleCardsSection";
import ReviewSection from "./components/ReviewSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <HeroSection />
      <ProblemSection />
      <FeatureGrid />
      <CategoryGrid />
      <CTASection />
      <ArticleCardsSection />
      <ReviewSection />
      <Footer />
    </main>
  );
}